<script>
    import PlaygroundHelper from '../../scripts/playgroundhelper';
    export let features = [];
</script>

<select multiple bind:value={features} size="6" class="form-control">
    {#each Object.keys(PlaygroundHelper.features) as feature}
        <option name="feature" id="feature-{feature}" value={parseInt(feature)}>{PlaygroundHelper.presentFeature(feature)}</option>
    {/each}
</select>

<style>
    select {
        font-size: inherit;
    }
</style>